import { UserClient } from '../types'
import { GetUserResponseData } from '../types'

export const passwordReset = (base: UserClient) => (password: string, private_key_armored: string, public_key_armored: string) =>
  base.requester.post<GetUserResponseData>('password-reset', { password, private_key_armored, public_key_armored }, { withCredentials: true })
